import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  data: null,
   message: null,
};

const reportExportSlice = createSlice({
  name: "reportExport",
  initialState,
  reducers: {
    exportReport: (state, action) => {
      state.loading = true;
      state.error = null;
      state.data = null;
      state.message = null;
    },
    exportReportSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.message = action.payload.message;
    },
    exportReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearReportData: (state) => {
      state.data = null;
      state.error = null;
      state.message = null;
    },
  },
});

export const { actions, reducer } = reportExportSlice;
export const sliceKey = reportExportSlice.name;